import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import SplitToggleButton from '~/components/Buttons/SplitToggleButton';
import { lineOptionsState, selectedToolState } from '~/state/atoms/toolsAtoms';
import LineDrawTool from './LineDrawTool';
import { SplineIcon } from 'lucide-react';
import { Stack } from '@mui/material';
import { primaryImageState } from '~/state/atoms/image/imageAtoms';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

export default function LineDrawToolComponent() {
    const [tool, setTool] = useRecoilState(selectedToolState);
    const primaryImage = useRecoilValue(primaryImageState);
    const selectedStructureSet = useRecoilValue(currentStructureSetState);
    const setLineOptions = useSetRecoilState(lineOptionsState);
    const [validationError, setValidationError] = useState<string | null>(null);
    const isDisabled =
        !selectedStructureSet || selectedStructureSet.roiArray.length === 0;

    useEffect(() => {
        if (validationError) {
            enqueueSnackbar(validationError, { variant: 'error' });
            setValidationError(null);
        }
    }, [validationError]);

    const handleToolSelect = () => {
        const isDatasetTilted = primaryImage?.firstSlice.tilted;
        if (isDatasetTilted) {
            setValidationError(
                'Line draw tool is not available for tilted datasets'
            );
            return;
        }
        setTool('line');
        setLineOptions((options) => ({
            ...options,
            mode: 'draw',
        }));
    };

    return (
        <SplitToggleButton
            isSelected={tool === 'line'}
            value="line"
            onToggle={() => handleToolSelect()}
            icon={<SplineIcon />}
            tooltipTitle="Line Draw"
            popperComponent={
                <Stack p={2} gap={2}>
                    <LineDrawTool />
                </Stack>
            }
            disabled={isDisabled}
        />
    );
}
